// extracted by mini-css-extract-plugin
export var anchored = "mediaSlideContent-module--anchored--f557d";
export var layoutReduced = "mediaSlideContent-module--layoutReduced--d1cb4";
export var mediaDescription = "mediaSlideContent-module--mediaDescription--5eed7";
export var mediaSlideContainer = "mediaSlideContent-module--mediaSlideContainer--31145";
export var mediaSlideMedia = "mediaSlideContent-module--mediaSlideMedia--8ec5e";
export var thumbnail = "mediaSlideContent-module--thumbnail--e0971";